import { Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { ErrorInfo, ErrorInfoHandler } from '@scisys-uim/uim-common';

@Injectable()
export class UnauthorisedErrorInfoHandler implements ErrorInfoHandler {
    public order: number = 100000;

    constructor(public router: Router) { }

    handleErrorInfo(errorInfo: ErrorInfo): boolean {
        if (errorInfo.handled) {
          return false;
        }
        if (errorInfo.code != 'Unauthorised') {
            return false;
        }
        this.router.navigate(['/unauthorised']);
        return true;
    }

}
